<!-- <div class="mat-typography mat-body mat-app-background"> -->
<h2 mat-dialog-title>{{data.modalTitle || "Have a Medicare advisor reach out to you."}}</h2>

<mat-dialog-content class="mat-typography">
  <p>
    {{data.modalText || "Fill out the form below and one of our representatives will call you soon." }}
  </p>

  <form class="need-more-help-form" [formGroup]="needMoreHelpFormGroup">
    <mat-form-field appearance="outline" class="name-form-fields">
      <mat-label>First Name</mat-label>
      <input matInput placeholder="First Name" formControlName="firstName" maxlength="25" #firstname>
      @if (formControls.firstName.errors?.minlength) {
        <mat-error>
          First name can not be shorter than {{formControls.firstName.errors?.minlength.requiredLength}} characters
        </mat-error>
      }
      @if (formControls.firstName.errors?.maxlength) {
        <mat-error>
          First name can not be greater than
          {{formControls.firstName.errors?.maxlength.requiredLength}}
          characters
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="name-form-fields">
      <mat-label>Last Name</mat-label>
      <input matInput placeholder="Last Name" formControlName="lastName" maxlength="25">
      @if (formControls.lastName.errors?.minlength) {
        <mat-error>
          Last name can not be shorter than {{formControls.lastName.errors?.minlength.requiredLength}} characters
        </mat-error>
      }
      @if (formControls.lastName.errors?.maxlength) {
        <mat-error>
          Last name can not be greater than {{formControls.lastName.errors?.maxlength.requiredLength}} characters
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="phone-email-form-fields">
      <mat-label>Phone</mat-label>
      <input matInput appNumbersOnly customValidator="PhoneNumber" placeholder="(___)___-____" formControlName="phone" required="true">
      @if (formControls.phone.errors) {
        <mat-error>
          Please enter a valid phone number
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="phone-email-form-fields">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" formControlName="email">
      @if (formControls.email.errors) {
        <mat-error class="error-wrapper">
          Please enter a valid email address
        </mat-error>
      }
    </mat-form-field>

    <mat-dialog-actions>
      <a id="need-more-help-cancel" href="javascript:void(0)" mat-button color="accent" (click)="closeModal()">
        CANCEL
      </a>
      <button id="need-more-help-submit" mat-raised-button color="primary" (click)="submit($event)" [disabled]="submitting">
        @if (!submitting) {
          <span>Submit</span>
        }
        @if (submitting) {
          <span>Submitting...</span>
        }
      </button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
<!-- </div> -->